import { ServerMessagesMapping } from '@core-models/messages/server-messages-mapping';

export const serverMessagesMapping: ServerMessagesMapping = {
    SignalR_Connection_Not_Found: {
        code: 400,
        messageTranslationPath: 'SERVER.ERRORS.SIGNALR_CONNECTION_NOT_FOUND',
        title: ''
    }
};